import { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import { FactorsCard } from "./card";
import { setDocumentTitle } from "@/lib/documentTitle";

import { FactorsTable } from "./table";

export default function Factor() {
  useEffect(() => {
    setDocumentTitle("Quantilia | Facteurs");
  }, []);

  return (
    <Routes>
      <Route index element={<FactorsTable />} />

      <Route path=":id" element={<FactorsCard />} />
    </Routes>
  );
}
